// src/components/routes/Landing/Landing.js

import React from "react";
import { Link } from "react-router-dom";
import "./Landing.css";

const Landing = () => {
    return (
        <div className="landing-container">
            <div className="landing-glow landing-glow-one" aria-hidden="true" />
            <div className="landing-glow landing-glow-two" aria-hidden="true" />

            <header className="landing-header">
                <Link to="/" className="landing-brand" aria-label="MultyComm home">
                    <img src="/uploads/logo.webp" className="logo-landing" alt="MultyComm" />
                </Link>
                <Link to="/login" className="landing-nav-link">
                    Sign in <i className="fas fa-arrow-right" aria-hidden="true" />
                </Link>
            </header>

            <main className="landing-content">
                <section className="landing-hero">
                    <div className="landing-copy">
                        <span className="landing-kicker">
                            <i className="fas fa-circle" aria-hidden="true" />
                            The connected business workspace
                        </span>
                        <h1 className="landing-heading">
                            Customer conversations,
                            <span> finally in sync.</span>
                        </h1>
                        <p className="landing-lede">
                            MultyComm gives every team the clarity to respond faster,
                            understand customers better and move business forward.
                        </p>
                        <div className="landing-actions">
                            <Link to="/login" className="continue-link">
                                Enter your workspace <i className="fas fa-arrow-right" />
                            </Link>
                            <span className="landing-safe-note">
                                <i className="fas fa-shield-alt" /> Secure access
                            </span>
                        </div>
                    </div>

                    <div className="landing-visual" aria-label="MultyComm workspace preview">
                        <div className="landing-dashboard">
                            <div className="preview-topbar">
                                <span className="preview-mark">M</span>
                                <div>
                                    <small>Good morning</small>
                                    <strong>Your command center</strong>
                                </div>
                                <span className="preview-avatar"><i className="fas fa-user" /></span>
                            </div>
                            <div className="preview-stats">
                                <div><small>Active enquiries</small><strong>248</strong><em>+12.4%</em></div>
                                <div><small>Response rate</small><strong>94%</strong><em>On track</em></div>
                            </div>
                            <div className="preview-chart">
                                <div className="preview-chart-head">
                                    <div><small>Conversation volume</small><strong>This week</strong></div>
                                    <span>Live</span>
                                </div>
                                <div className="preview-bars">
                                    {[44, 62, 51, 78, 67, 91, 73].map((height, index) => (
                                        <i key={index} style={{ height: `${height}%` }} />
                                    ))}
                                </div>
                            </div>
                            <div className="preview-activity">
                                <span className="preview-pulse"><i className="fas fa-check" /></span>
                                <div><strong>Customer follow-up completed</strong><small>Just now · Adidas team</small></div>
                            </div>
                        </div>
                        <div className="landing-float-card landing-float-top">
                            <span><i className="fas fa-bolt" /></span>
                            <div><strong>Real-time clarity</strong><small>Every team, one view</small></div>
                        </div>
                        <div className="landing-float-card landing-float-bottom">
                            <span><i className="fas fa-headset" /></span>
                            <div><strong>Customer first</strong><small>Context that travels</small></div>
                        </div>
                    </div>
                </section>

                <section className="landing-proof" aria-label="Platform highlights">
                    <span>Built for modern customer teams</span>
                    <div><strong>One workspace</strong><small>for every interaction</small></div>
                    <div><strong>Faster follow-up</strong><small>with shared context</small></div>
                    <div><strong>Clear ownership</strong><small>across every team</small></div>
                </section>
            </main>
        </div>
    );
}

export default Landing;
